import { useParams } from 'react-router-dom'
import { useStats } from '../ctx/stats'
import { useCallback, useEffect } from 'react'
import { useUser } from 'hooks'
import { useQuery } from 'react-query'

export const useLoadStats = () => {
  const { id: paramId } = useParams()
  const { user } = useUser()
  const [setStatsUserId, statsUserId, getStats, getStatsV2, status, isV2] =
    useStats((s) => [
      s.setStatsUserId,
      s.statsUserId,
      s.getStats,
      s.getStatsV2,
      s.status,
      s.isV2,
    ])

  const getUserId = useCallback(() => {
    return statsUserId || paramId || user?.id || ''
  }, [paramId, user, statsUserId])

  const loadStatsUserId = useCallback(() => {
    if (!statsUserId) setStatsUserId(getUserId())
  }, [setStatsUserId, getUserId, statsUserId])

  useEffect(() => {
    loadStatsUserId()
  }, [loadStatsUserId])

  const fetchStats = isV2 ? getStatsV2 : getStats

  useQuery(
    ['user-stats', statsUserId],
    async () =>
      await fetchStats({
        status: status === 'idle' ? 'refreshing' : 'loading',
      }),
    {
      enabled: !!statsUserId,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
    }
  )
}
